
import "./SettingsDropdown.css"

export default function SettingsDropdown({setFontSize, currFontSize, setShowLineNumbers, showLineNumbers, lightMode, setLightMode}){
    return(
            <div className="dropdown-container">
                <div className="settings-option">
                    <div className="font-size-setting">
                        <div className="font-size-settings-text">
                            Font Size
                        </div>
                        <button 
                            onClick={() => {
                                const newFontSize = parseInt(currFontSize, 10) + 1;
                                setFontSize(newFontSize);
                                sessionStorage.setItem("Font Size", newFontSize) 
                            }}
                            className="font-button"
                        > 
                            + 
                        </button>
                        <input value={currFontSize} className="font-size-input"/>
                        <button 
                            onClick={() => {
                                const newFontSize = parseInt(currFontSize, 10) - 1;
                                setFontSize(newFontSize);
                                sessionStorage.setItem("Font Size", newFontSize) 
                            }}
                            className="font-button"
                        > 
                            − 
                        </button>
                    </div>
                </div>
                
                <div className="settings-option">
                    <div className="light-mode-setting"> 
                        <div className="light-mode-text">
                            Light Mode
                        </div>

                        <div className="ligt-mode-button-wrapper">
                            <input type="checkbox" id="check2"  className="toggle-light"
                                    checked={lightMode}                          
                                    onChange={e => {
                                        const lightMode = e.target.checked
                                        setLightMode(lightMode)
                                        sessionStorage.setItem("Light Mode", lightMode)
                                        console.log("Setting/Caching Light mode to: ", lightMode)
                                    }}  
                            />
                            <label htmlFor="check2" />
                        </div>
                    </div>
                </div>

                <div className="settings-option">
                    <div className="line-numbers-setting">
                        
                        <div className="line-number-text">
                            Line Numbers
                        </div>

                        <div className="line-number-button-wrapper">

                            <input type="checkbox" id="check1"  className="toggle"
                                checked={showLineNumbers}                          
                                onChange={e => {
                                    setShowLineNumbers(e.target.checked)
                                    sessionStorage.setItem("Line Numbers", e.target.checked)
                                }} 
                            />
                            <label htmlFor="check1" />

                        </div>
                       
                     

                    </div>
                </div>
            </div>
        );
}